import React from 'react'
import './ProductIndex.less'
import { goIndex } from '@/assets/js/utils'

function Product ({ buriedPointEvent, data: { id, position, sublist = [], trackId, style, title } }) {
    if (!style) style = { paddingTop: 0 }
    return (
        <div className="product-index-wrap" style={{ paddingTop: `${style.paddingTop / 75}rem` }}>
            <div
                className="product-index-inner"
                style={{ width: `${710 / 75 * sublist.length}rem` }}
            >
                {sublist.map((item, index) => (
                    <div
                        key={item.id}
                        className="product-index-box statistics-dom"
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${trackId}-${item.title}`,
                                button_id: `${item.id}`,
                                button_order: `${index + 1}`,
                                area_order: position,
                                button_area: `${position}-${trackId}`
                            })
                            goIndex(item.url, trackId, item.keyword, item)
                        }}
                    >
                        <div className="product-index">
                            <div className="line">
                                {item.productMark && <div className="productMark">{item.productMark}</div>}
                                <div className="businessLineName">{item.businessLineName}-{item.title}</div>
                                <div className="productTrait">{item.productTrait}</div>
                            </div>
                            <div className="rate">{item.rate}<span>%</span></div>
                            <div className="rateName">{item.rateName}</div>
                            <div className="label"><span>{item.label1}</span><span>{item.label2}</span></div>
                            <div className="btnName">{item.btnName}</div>
                            <div className="tip">参考年化回报率不承诺等于实际收益</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Product
